

export function UpdateHistory(register, clashBotData, time, titleStatement, smallStatements, setHistory) {

  const newItem = {
    time: time,
    titleStatement: titleStatement ? titleStatement : '',
    smallStatements: smallStatements ? smallStatements : [],
    register: [...register],
    clashBotData: [...clashBotData],
  }

  setHistory((prev) => [...prev, {...newItem}]);

}